module.exports = __webpack_public_path__ + "img/code_bg.cf52f804.png";